import toggle from './nav-toggle.js';
import credits from './image-credit.js';
import './tabbing-navigation.js';
import SubmenuNavigation from './submenu-navigation.js';
import Search from './search-toggle.js';

import '../sass/style.scss';

( function( $ ) {

    $( document ).ready( function() {

        $( 'body' ).removeClass( 'no-js' );

        let navToggle = new toggle();
        navToggle.init();

        let Credits = new credits();
        Credits.init();

        let subNav = new SubmenuNavigation();
        subNav.init();

        let sToggle = new Search();
        sToggle.init();

        $('a[href^="#"]').click( function(event) {
            event.preventDefault();

            // Get the current target hash
            var target = this.hash;

            // Animate the scroll bar action so its smooth instead of a hard jump
            $('html, body').stop().animate({
                'scrollTop' : $(target).offset().top - 120 + 'px'
            }, 300 );

        });

    });

})( jQuery );
